export default "__VITE_ASSET__MH7MeSkU__"